export class TblSMSTemplate
{
    refNo:number
    templateId:string;
    templateName:string;
    templateDetails:string;
    active:string;
}